<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Folio</th>
            <th :class="StyleTh">Recibe</th>
            <th :class="StyleTh">Fecha Registro</th>
            <th :class="StyleTh">Fecha Salida</th>
            <th :class="StyleTh">Solicitud Asociada</th>
            <th :class="StyleTh">Estatus</th>
            <th :class="StyleTh">Tipo Salida</th>
                
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Folio}}</p></td>
                    <td><p :class="StyleTd">{{lista.NombreResponsableRecibe}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaRegistro}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaSalida}}</p></td>
                    <td><p :class="StyleTd">{{lista.SalidaAsociada}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus}}</p></td>
                    <td><p :class="StyleTd">{{lista.TipoSalida}}</p></td>
                    
                <td class="align-middle text-end">
                    <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="(lista.Estatus!='Elaborado')?false:true" :pIsModal="false" :pId="lista.IdSolicitudAlmacen" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                        <template slot="btnaccion">
                            <CMoreButtonsL v-if="lista.Estatus !='Autorizado'">
                                <template slot="bodyBtnsL">
                                    <template v-if="segurity.RequestAuthorization">
                                        <li v-if="lista.Estatus == 'Elaborado'" @click="CambiarEstatusSalida(lista,1)">
                                            <a class="dropdown-item">
                                                <i class="far fa-user"></i> Solicitar Autorización
                                            </a>
                                        </li>
                                    </template>
                                    <template v-if="segurity.Authorize">
                                        <li v-if="lista.Estatus == 'PreAutorizado'" @click="CambiarEstatusSalida(lista,2)">
                                            <a class="dropdown-item">
                                                <i class="far fa-check-circle"></i> Autorizar
                                            </a>
                                        </li>
                                    </template>
                                    <template v-if="segurity.Reject">
                                        <li v-if="lista.Estatus == 'PreAutorizado'" @click="CambiarEstatusSalida(lista,3)">
                                            <a class="dropdown-item">
                                                <i class="far fa-times-circle"></i> Rechazar
                                            </a>
                                        </li>
                                    </template>
                                </template>
                            </CMoreButtonsL>
                        </template>
                    </CBtnAccion>     
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionNotaPago';

export default {
    name: 'ListaNotaPago',
    props: ['sFiltros','pOrigen'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado de Salidas',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                GoRoute: 'solicitudSalidaForm',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("solicitudesAlmacen",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    TipoSalida:'Materiales'
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('solicitudesAlmacen/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        CambiarEstatusSalida(item,Tipo)
        {
            this.ConfigList.ShowLoader = true;

            let msg   = '';

            if(Tipo == '1'){
                msg = '¿Solicitar Autorización?';
            } else if(Tipo == '2') {
                msg = '¿Autorizar?';
            } else if(Tipo == '3') {
                msg = '¿Rechazar Salida?';
            }

            this.$swal({
                title: msg,
                text: 'Esta acción no se podra revertir',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
            }).then((result) => {
                if(result.value) {

                    this.$http.get("solicitudAlmacenEstatus",{
                        params:{
                            IdSolicitudAlmacen: item.IdSolicitudAlmacen,
                            Operacion: Tipo,
                        }
                    }).then((res) => {
                        this.$toast.success('Estatus Cambiado');
                        this.Lista();
                    }).finally(()=>{
                        this.ConfigList.ShowLoader = false;
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                }
                else{
                    this.ConfigList.ShowLoader = false;
                }
            });
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
